<div class="header">
    <span class="title">Upload history</span>
    <div class="litmus-multi-request-upload-paging">
        <button [disabled]="!pagingButtons.isPrevious" (click)="paginateOutbox('previous')">
            <img src="assets/images/chevron-left.svg" />
        </button>
        <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}}
        </span>
        <button [disabled]="!pagingButtons.isNext" (click)="paginateOutbox('next')">
            <img src="assets/images/chevron-right.svg" />
        </button>
    </div>
</div>
<div *ngIf="isDataLoaded == false; else tableData" style="height: 50vh;">
    <app-ltms-loader></app-ltms-loader>
</div>
<ng-template #tableData>
    <app-ltms-data-table-v2
    [ngStyle]="{ 'white-space': 'normal' }"
    [columns]="headers"
    [data]="uploadHistory">
  </app-ltms-data-table-v2>
</ng-template>
